import React from 'react';

import { useIntl } from 'react-intl';

import { NavEmptyState } from '@atlassian/navigation-common/ui/nav-empty-state';

import { messages } from '../messages';

export const ErrorState = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<NavEmptyState
			header={formatMessage(messages.loadErrorTitle)}
			description={formatMessage(messages.loadErrorMessage)}
		/>
	);
};
